const cpfError =
  'O <strong>CPF</strong> informado <strong>não foi localizado</strong> em nossas bases de consulta. Por favor, revise e tente novamente';

export const handleErrorMsg = function (value, type, data = null) {
  let message = '';

  if (type.toLowerCase() === 'cpf') {
    message = cpfError;
  } else {
    message = `Ops. Não foi possível prosseguir com a informação de ${type}. Por favor, tente novamente`;
  }

  if (value) {
    if (value == 'Pessoa exposta politicamente') {
      message =
        'Identificamos que o CPF informado pertence à uma PEP (Pessoa Exposta Politicamente), Por isso <strong>' +
        data.data.nome +
        '</strong>, compareça à uma <strong>agência física</strong> para que possamos prosseguir com a simulação e realizar o seu sonho';
    } else if (!value.includes('null')) {
      message = value;
    }

    if (value.includes('erro') || value.includes('Undefined')) {
      if (type.toLowerCase() === 'cpf') {
        message = cpfError;
      } else {
        message = 'Ops, simulação interrompida por falha técnica';
      }
    }
  }

  return message;
};

export const removeTimeFromDate = function (value) {
  if (!value) {
    return null;
  }

  return value.replace('T00:00:00.000000Z', '');
};

export const storeMixins_prepareSearchText = function (value) {
  return value.replace(/[^a-zA-ZÀ-ÿ0-9 ]/g, '').trim();
};
